import { Box, Button, Grid } from "@mui/material"
import { createRef, useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import { SnackSimple } from "../../../../../../../../components"
import { FloatFilter } from "../../../../../../../../components/filtersDrawer/floatFilter"
import SimpleModal from "../../../../../../../../components/modal/simpleModal"
import { useTimeOut } from "../../../../../../../../hooks/timeOut"
import { CodeDeleteActivity, CodeFinishActivity, CodeStartActivity } from "../../../../../../../../service/logbook/response"
import { loogbookServiceFetch } from "../../../../../../../../utils/constants/callService"
import { RequestErrors, Types } from "../../../../../../../../utils/enums"
import { returnQuery, returnQueryWithPagination } from "../../../../../../../../utils/methods/returnQuery"
import { ModalType, onChange } from "../../../../../../../../utils/types/generals"
import { useLogbookContext } from "../../../../context"
import { ActivitySection, QueryActivity } from "../../../../utils"
import { ActivityMap } from "../../../shared"
import { DeleteActivity, SeeReport } from "../../utils/types"
import { UserActivity } from "../../activityDetail/users"
import { BaseMenuClick } from "../../../../../../../../components/baseMenu"
import { menuOptions } from "../../mapLeft/menuOptions"
import { CancelActivity } from "../../../shared/detail/components/cancelActivity"
import { ReScheduleActivity } from "../../../shared/detail/components/reSchedule"
import { ResendActivity } from "../../../shared/detail/components/resend"
import { handleAllErrors } from "../../../../../../../../utils/methods/handleErrors"
import dayjs from "dayjs"
import { Constants } from "../../../../../../../../utils/constants"
import useGeolocation from "../../../../../../../../hooks/localization"
import { FinishActivityBody, StartActivityBody } from "../../../../../../../../service/logbook/body"
import { geoDistanceInMeters } from "../../../../../../../../utils/methods/calcDistanceFromLatAndLong"
import { getLocalStorage, LocaleNameType } from "../../../../../../../../utils/crud/crypt"
import { CancelActivityRef } from "../../../shared/detail/components/cancelActivity/types"
import { useStyles } from "./styles"
import { ForceClosureActivity } from "../../../shared/detail/components/forceClosure"
import { ConfirmActivityAction } from "../../../shared/detail/utils/enums"
import { ReScheduleActivityRef } from "../../../shared/detail/components/reSchedule/types"
import { toUnitTimeZone } from "../../../../../../../../utils/methods/calcDate"
import { TimeZoneGneral } from "../../../shared/detail/types"
import { ResendActivityRef } from "../../../shared/detail/components/resend/types"
import { CodeResendActivity } from "../../../../../../../../service/logbook/response/resendActivity"
import { PointType } from "../../../../utils/enums/pointType"
import { icons } from "../../../../../../../../utils/icons"
import { ChildrenCoordinates } from "../../../shared/activityOnMap/types"

export const ActivityUsers = () => {
    const { executeFunction } = useTimeOut()
    const location = useLocation()
    const styles = useStyles()
    const [snackbar, setSnackbar] = useState({ open: false, message: '', type: Types.SUCCESS as string, })
    const { state, service, filter, loadingUserList, hiddenLocalConstant, setHiddenLocalConstant, visibleUsersDataGeneralList, setVisibleUsersDataGeneralList, setVisibleUsersDataByUser } = useLogbookContext()
    const { activitySection, usersIds } = useMemo(() => {
        const queary = new URLSearchParams(location.search)
        const activitySection: ActivitySection = Number(queary.get(QueryActivity.ACTIVITY)) ?? ActivitySection.USER_LIST
        setVisibleUsersDataByUser({})
        const userInfo = JSON.parse(queary.get(QueryActivity.USER) ?? '{}')
        const usersIds: string[] = queary.get(QueryActivity.IDS)?.split(',') ?? []

        return { activitySection, userInfo: { ...userInfo, area: userInfo?.area?.split(','), department: userInfo?.department?.split(',') }, usersIds }
    }, [location.search])

    const { activityRegister: { activity: { userList, usersMark, total } }, loadings: loadingContext, } = state
    const { t } = useTranslation()
    const [modal, setModal] = useState<ModalType>({ open: false, description: '', title: '' })
    const filters = {
        [ActivitySection.USER_LIST]: filter.filterUser,
        [ActivitySection.ONE_USER_ACTIVITY]: filter.filterOneUser,
        [ActivitySection.USER_LIST_ACTIVITY]: filter.filterListUser,
    }
    const filterUser = filters[activitySection].filter
    const input = filters[activitySection].input
    const visibleUsersList = Object.values(visibleUsersDataGeneralList);
    const { location: geoLocation, error } = useGeolocation()
    const cancelRef = createRef<CancelActivityRef>()
    const reAcheduleRef = createRef<ReScheduleActivityRef>()
    const resendRef = createRef<ResendActivityRef>()
    const branding = getLocalStorage<any>(LocaleNameType.SETTING)
    const [page, setPage] = useState(1)
    const [expandMap, setExpandMap] = useState(true)
    const [viewLocal, setViewLocal] = useState<string[]>([])
    const [isPagintaion, setIsPagination] = useState(true)
    const [oldFilterString, setOldFilterString] = useState('')
    const displayHidden = ({ id, list, visible, activitiesId }: { id: string, list?: boolean, visible?: boolean, activitiesId?: string[] }) => {
        if (list && activitiesId) {
            setHiddenLocalConstant((prevHiddenLocal) => {
                if (visible) {
                    // Filtrar elementos de usersToHidde que empiezan con el id
                    const toMoveToView = prevHiddenLocal.filter((fullId) => fullId.startsWith(`${id}-`));
                    // Agregar a viewLocal
                    setViewLocal((prev) => [...prev, ...toMoveToView]);

                    // Remover de usersToHidde
                    return prevHiddenLocal.filter((fullId) => !fullId.startsWith(`${id}-`));
                } else {
                    // Filtrar elementos de viewLocal que empiezan con el id
                    const toMoveToHidden = viewLocal.filter((fullId) => fullId.startsWith(`${id}-`));

                    // Agregar a usersToHidde
                    const toAdd = toMoveToHidden.filter((fullId) => !prevHiddenLocal.includes(fullId));
                    const newHidden = [...prevHiddenLocal, ...toAdd];

                    // Eliminar de viewLocal
                    setViewLocal((prev) => prev.filter((fullId) => !fullId.startsWith(`${id}-`)));

                    return newHidden;
                }
            });
        } else {
            setHiddenLocalConstant(prev => {
                const existUser = prev.some(userId => userId == id)
                if (existUser) { setViewLocal(prev => [...prev, id]) } else { setViewLocal(prev => prev.filter(userId => userId != id)) }
                return existUser ? prev.filter(userId => userId != id) : [...prev, id]
            })
        }
    }
    const closeModal = () => {
        setModal({ description: '', open: false, title: '' })
    }
    const loadingModal = (value: boolean) => {
        setModal(prev => ({ ...prev, loading: value }))
    }
    const closeSnackbar = () => { setSnackbar(prev => ({ ...prev, open: false })) }
    const seeReport: SeeReport = async ({ id }) => {
        setSnackbar({ message: t('loogbook.snackbar.loadingReport'), open: true, type: Types.INFO })
        const response = await loogbookServiceFetch.seeInform({ id: Number(id) })

        if (response.errors) {
            setSnackbar({ message: t('loogbook.snackbar.seeInform.error'), open: true, type: Types.ERROR })
        } else {
            window.open(response.reportUrl, '_blank');
        }

    }
    const deleteActivity: DeleteActivity = ({ id }) => {
        setModal(prev => ({
            ...prev,
            open: true,
            description: t('loogbook.modal.deleteActivity'),
            title: t('general.confirm'),
            confirm: async () => {
                setModal(prev => ({ ...prev, loading: true }))
                const response = await service.deleteActivity({ id: id })
                setModal(prev => ({ ...prev, loading: false }))
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    activities()
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.deleteActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.deleteActivity.error'), open: true, type: Types.ERROR })
            },
            cancel: closeModal
        }))
    }
    const confirmCancel = async ({ id }: { id: string }) => {
        if (cancelRef.current) {
            const reason = cancelRef.current?.getData?.reason?.trim()
            cancelRef.current.loading(true)
            if (!!reason) {
                const response = await loogbookServiceFetch.cancelActivities({ id: id, body: { closeMotive: reason, } })
                cancelRef.current.loading(false)
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    activities()
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.cancelActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.cancelActivity.error'), open: true, type: Types.ERROR })
            }
        }
    }
    const cancelActivity = async ({ id }: { id: string }) => {
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <CancelActivity
                    cancel={closeModal}
                    confirm={() => { confirmCancel({ id }) }}
                    ref={cancelRef}
                />,
            description: t('general.cancelReason'),
            sx: styles.cancelStyles,
            title: t('general.cancelActivity'),
            confirmText: t('general.cancelActivity'),
        }))
    }
    const reScheduleActivity = async ({ id, timeZone, startDate, endDate }: { id: string; timeZone: TimeZoneGneral; startDate: dayjs.Dayjs | null; endDate: dayjs.Dayjs | null }) => {
        const isValidatedStartDate = dayjs().isAfter(startDate)
        const isValidatedEndDate = dayjs().isAfter(endDate)
        const dateStart = startDate ? dayjs(startDate) : dayjs()
        const dateEnd = endDate ? dayjs(endDate) : null
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <ReScheduleActivity
                    timeZone={timeZone}
                    defaultDate={{
                        from: isValidatedStartDate ? dayjs(toUnitTimeZone(new Date(), timeZone.value)) : dateStart,
                        to: isValidatedEndDate ? null : dateEnd,
                    }}
                    cancel={closeModal}
                    confirm={() => { confirmReSchedule({ id, timeZone }) }}
                    ref={reAcheduleRef}
                />,
            description: '',
            sx: styles.cancelStyles,
            title: t('loogbook.reScheduleActivity'),
            confirmText: t('general.reSchedule'),
        }))
    }
    const confirmReSchedule = async ({ id, timeZone }: { id: string; timeZone: TimeZoneGneral; }) => {
        if (reAcheduleRef.current) {
            const dates = reAcheduleRef.current?.getData
            reAcheduleRef.current.loading(true)
            if (!!dates) {
                const response = await loogbookServiceFetch.reScheduleActivities({
                    id: id,
                    body: {
                        dateEnd: dayjs(dates.to).format(Constants.dayjsFormat3),
                        dateStart: dayjs(dates.from).format(Constants.dayjsFormat3),
                        ...(!!timeZone?.id) && { timeZone: timeZone?.id },
                    }
                })
                reAcheduleRef.current.loading(false)
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    activities()
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.reScheduleActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: handleAllErrors(response.errors?.[0]?.code ?? RequestErrors.ERR_AUTH, t), open: true, type: Types.ERROR })
            }
        }
    }
    const confirmResend = async ({ id }: { id: string }) => {
        if (resendRef.current) {
            const resendData = resendRef.current?.getData
            resendRef.current.loading(true)
            if (!!resendData) {
                const response = await loogbookServiceFetch.resendActivities({
                    body: {
                        external_emails: resendData.emails?.split(',').filter(email => !!email).map(email => email.trim()) ?? [],
                        user_ids: resendData.usersIds ?? [],
                        id: id,
                    }
                })
                resendRef.current.loading(false)
                if (response.code == CodeResendActivity.SUCCESS) {
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.resendActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.resendActivity.error'), open: true, type: Types.ERROR })
            }
        }
    }
    const resendActivity = async ({ id, timeZone }: { id: string; timeZone: TimeZoneGneral; }) => {
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <ResendActivity
                    timeZone={timeZone}
                    cancel={closeModal}
                    confirm={() => { confirmResend({ id }) }}
                    ref={resendRef}
                />,
            description: '',
            sx: styles.cancelStyles,
            title: t('general.resendReport'),
            confirmText: t('general.reSchedule'),
        }))
    }
    const isIntoTheRange = ({ geofence, storePoint }: { geofence: boolean; storePoint: { lat: string; lng: string; locationInitSiteName: string; } }) => {
        const fence: number = branding?.brandy?.configLocations?.digitalFenceMts ?? 0

        if (!geofence || !fence) {
            return { intoRange: true }
        }

        const userLat = geoLocation.lat?.toString() ?? ''
        const userLng = geoLocation.lng?.toString() ?? ''
        if (storePoint) {
            const meters = Math.abs(Number(geoDistanceInMeters({ from: { lat: userLat, lng: userLng }, to: { lat: storePoint.lat, lng: storePoint.lng } })) ?? 0)
            const intoRange = fence >= meters
            if (!intoRange) {
                setSnackbar({ open: true, message: t('loogbook.snackbar.range.youAreOutside'), type: Types.ERROR })
            }
            return { intoRange }
        }

        setSnackbar({ open: true, message: t('loogbook.snackbar.range.thereNoRange'), type: Types.ERROR })
        return { intoRange: true, thereNoLocation: true }
    }
    const startActivity = async ({ id, initDate, geofence, storePoint }: { id: string, initDate: dayjs.Dayjs | null, geofence: boolean; storePoint: { lat: string, lng: string; locationInitSiteName: string; } }) => {
        const startDate = dayjs.utc(initDate).format(Constants.dayjsFormat3)
        const validateDate = initDate ? dayjs().isBefore(dayjs(startDate), 'seconds') : false
        if (validateDate) {
            setSnackbar({ open: true, message: t('loogbook.snackbar.startActivity.pastDate'), type: Types.ERROR })
            return
        }
        loadingModal(true)
        const userLat = geoLocation.lat?.toString() ?? ''
        const userLng = geoLocation.lng?.toString() ?? ''
        const body: StartActivityBody = {
            isMobile: false,
            latitude: userLat,
            longitude: userLng
        }
        const validateRange = isIntoTheRange({ geofence, storePoint })
        if (validateRange.intoRange) {
            const response = await loogbookServiceFetch.startActivity({ id: id, body })
            loadingModal(false)
            if (response.code == CodeStartActivity.SUCCESS) {
                activities()
                setSnackbar({ open: true, message: t('loogbook.snackbar.startActivity.success'), type: Types.SUCCESS })
                closeModal()
                return
            }
            setSnackbar({ open: true, message: handleAllErrors(response?.errors?.[0]?.code, t, 'loogbook.snackbar.startActivity.error'), type: Types.ERROR })
            return
        } else {
            loadingModal(false)
            setSnackbar({ open: true, message: t('loogbook.modal.startActivityOutRange'), type: Types.ERROR })
        }
    }
    const finishActivity = async ({ id, geofence, storePoint, someIsRequired }: { id: string, geofence: boolean; storePoint: { lat: string; lng: string; locationInitSiteName: string; }, someIsRequired: boolean }) => {

        if (someIsRequired) {
            //evidenceUpload.setShowRequireds(true)
            setSnackbar({ message: t('loogbook.snackbar.requiredFields'), open: true, type: Types.ERROR })
            closeModal()
            return
        }
        loadingModal(true)
        const body: FinishActivityBody = {
            isMobile: false,
            latitude: geoLocation.lat?.toString() ?? '',
            longitude: geoLocation.lng?.toString() ?? ''
        }
        const validateRange = isIntoTheRange({ geofence, storePoint })
        if (validateRange.intoRange) {
            const response = await loogbookServiceFetch.finsihActivity({ id: id, body })
            loadingModal(false)
            if (response.code == CodeFinishActivity.SUCCESS) {
                activities()
                setSnackbar({ open: true, message: t('loogbook.snackbar.finishActivity.success'), type: Types.SUCCESS })
                closeModal()
                return
            }
            setSnackbar({ open: true, message: handleAllErrors(response?.errors?.[0]?.code, t, 'loogbook.snackbar.finishActivity.error'), type: Types.ERROR })
        } else {
            loadingModal(false)
            setSnackbar({ open: true, message: t('loogbook.modal.finishActivityOutRange'), type: Types.ERROR })
        }
    }
    const confirmActiveOrFinish = ({ action, geofence, id, initDate, someIsRequired, storePoint }: { action: ConfirmActivityAction, id: string, initDate: dayjs.Dayjs | null, geofence: boolean; storePoint: { lat: string, lng: string; locationInitSiteName: string; }, someIsRequired: boolean }) => {
        let title = ''
        let confirm = () => { }
        switch (action) {
            case ConfirmActivityAction.START: {
                title = t('loogbook.modal.start.title')
                confirm = () => { startActivity({ geofence, id, initDate, storePoint }) }
                break
            }
            case ConfirmActivityAction.FINISH: {
                title = t('loogbook.modal.finish.title')
                confirm = () => { finishActivity({ geofence, id, someIsRequired, storePoint }) }
                break
            }
        }
        setModal(prev => ({
            ...prev,
            open: true,
            title: title,
            confirm,
            cancel: closeModal
        }))
    }
    const forceClosureActivity = async ({ geofence, id, storePoint }: { id: string, geofence: boolean; storePoint: { lat: string; lng: string; locationInitSiteName: string; } }) => {
        setModal(prev => ({
            ...prev,
            open: true,
            removeButtons: true,
            children:
                <ForceClosureActivity
                    cancel={closeModal}
                    confirm={() => { confirmForcingClose({ id, storePoint }) }}
                    ref={cancelRef}
                />,
            description: isIntoTheRange({ geofence, storePoint }).intoRange ? t('general.forcingDescriptionIntoRange') : t('general.forcingDescriptionOutRange'),
            sx: styles.cancelStyles,
            title: t('general.forcingClosure'),
            confirmText: t('general.cancelActivity'),
        }))
    }
    const confirmForcingClose = async ({ id, storePoint }: { id: string, storePoint: { lat: string; lng: string; locationInitSiteName: string; } }) => {
        if (cancelRef.current) {
            const reason = cancelRef.current?.getData?.reason?.trim()
            cancelRef.current.loading(true)
            if (!!reason) {
                const userLat = geoLocation.lat?.toString() ?? ''
                const userLng = geoLocation.lng?.toString() ?? ''
                const response = await loogbookServiceFetch.forceActivities({
                    id: id, body: {
                        closeMotive: reason,
                        isMobile: false,
                        latitude: userLat,
                        longitude: userLng,
                        locationInitSiteName: storePoint?.locationInitSiteName ?? ''
                    }
                })
                cancelRef.current.loading(false)
                if (response.code == CodeDeleteActivity.SUCCESS) {
                    activities()
                    closeModal()
                    setSnackbar({ message: t('loogbook.snackbar.forceActivity.success'), open: true, type: Types.SUCCESS })
                    return
                }
                setSnackbar({ message: t('loogbook.snackbar.forceActivity.error'), open: true, type: Types.ERROR })
            }
        }
    }
    const activities = async () => {
        if (activitySection == ActivitySection.USER_LIST) {
            loadingUserList()
            executeFunction({
                execute: async () => {
                    const { users } = await service.usersMarkList({ query: returnQuery(filterUser.query) })
                    const local = users.map(user => user.user.id)
                    //setUsersToHidde(local);
                    const visibleUserIds = Object.values(visibleUsersDataGeneralList).map(user => user.user.id);
                    const hiddenLocal = local
                        ?.filter(mark => !visibleUserIds.some(visibleId => visibleId == mark))
                        .map(mark => mark);
                    const hiddenLocalCopy = local
                        .map(mark => mark);
                    setHiddenLocalConstant(isPagintaion ? hiddenLocal : hiddenLocalCopy);
                    setHidenLocalCopy(hiddenLocalCopy)
                }
            })
            return
        }
    }
    const onChangeAll: onChange = ({ target }) => {
        const { name } = target

        const socialNames = ['from', 'to', 'area', 'department', 'stores'].includes(name)

        if (socialNames) {
            filter.filterUser.filter.onChange({ target });
            filter.filterListUser.filter.onChange({ target });
            filter.filterOneUser.filter.onChange({ target });
        } else {
            filterUser.onChange({ target })
        }
    }
    const cleanFilterAll = () => {
        filter.filterListUser.filter.cleanFilter()
        filter.filterOneUser.filter.cleanFilter()
        filter.filterUser.filter.cleanFilter()
        if (activitySection == ActivitySection.USER_LIST) {
            setVisibleUsersDataGeneralList({})
        } else {
            setVisibleUsersDataByUser({})
        }
        setIsPagination(true)
    }

    /* useEffect(() => {
        if (activitySection == ActivitySection.USER_LIST && usersMark?.length) {

            setVisibleUsersDataGeneralList((prev) => {
                const updatedUsersData = { ...prev };
                const newVisibleUsers = usersMark.filter((userMark) => {
                    const userIdPart = userMark.user.id;
                    return !hiddenLocalConstant.includes(userIdPart);
                });

                const userCountMap: Record<string, number> = {};

                Object.values(visibleUsersDataGeneralList).forEach((userMark) => {
                    console.log({ userMark })
                    const userId = userMark.user.userId;
                    if (!userCountMap[userId]) {
                        userCountMap[userId] = 1;
                    }
                });

                newVisibleUsers.forEach((userMark) => {
                    const userId = userMark.user.userId;

                    userMark.points.forEach((point) => {
                        const [, second] = point.extraData?.split('.') ?? ['0', '0'];
                        point.extraData = `${userCountMap[userId]}${second ? `.${second}` : ''}`; // Asigna el índice
                    });

                    userMark.index = userCountMap[userId];
                    userCountMap[userId] += 1;


                    // Guardamos el userMark si aún no estaba agregado
                    if (!updatedUsersData[userMark.user.id]) {
                        updatedUsersData[userMark.user.id] = userMark;
                    }
                });


                hiddenLocalConstant.forEach((userId) => {
                    Object.keys(updatedUsersData).forEach((key) => {
                        const keyPart = key;
                        if (keyPart === userId) {
                            delete updatedUsersData[key];
                        }
                    });
                });
                return updatedUsersData;
            });
        }
    }, [usersMark, hiddenLocalConstant]); */

    useEffect(() => {
        if (activitySection === ActivitySection.USER_LIST && usersMark?.length) {
            if (isPagintaion) {
                const newVisibleUsers = usersMark.filter((userMark) => {
                    return !hiddenLocalConstant.includes(userMark.user.id);
                });

                setVisibleUsersDataGeneralList((prev) => {
                    const updated = { ...prev };
                    newVisibleUsers.forEach((userMark) => {
                        if (!updated[userMark.user.id]) {
                            updated[userMark.user.id] = { ...userMark }; // copia sin mutar original
                        }
                    });

                    // También eliminamos los ocultos
                    hiddenLocalConstant.forEach((userId) => {
                        delete updated[userId];
                    });

                    return updated;
                });
            } else {
                const hiddenIds = new Set(hiddenLocalConstant);

                setVisibleUsersDataGeneralList(() => {
                    const updated: Record<string, typeof usersMark[0]> = {};

                    usersMark.forEach((userMark) => {
                        const userId = userMark.user.id;
                        if (!hiddenIds.has(userId)) {
                            updated[userId] = { ...userMark }; // copia segura
                        }
                    });

                    return updated;
                });
            }
        }
    }, [usersMark, hiddenLocalConstant]);


    /* const [countByCoordinates, setCountByCoordinates] = useState<Record<string, number>>({});

useEffect(() => {
    if (activitySection !== ActivitySection.USER_LIST) return;

    const newCountByCoordinates: Record<string, number> = {};
    for (const key in visibleUsersDataGeneralList) {
        const pointArray = visibleUsersDataGeneralList[key].points;
        for (const point of pointArray) {
            if (point.isUnity) {
                const coordKey = `${point.lat},${point.lng}`;
                newCountByCoordinates[coordKey] = (newCountByCoordinates[coordKey] || 0) + 1;
            }
        }
    }

    setCountByCoordinates(newCountByCoordinates);
}, [activitySection, visibleUsersDataGeneralList]);

useEffect(() => {
    if (activitySection !== ActivitySection.USER_LIST) return;

    setVisibleUsersDataGeneralList((prev) => {
        const userCountMap: Record<string, number> = {};
        const updated = { ...prev };
        let hasChanged = false;

        Object.values(updated).forEach((userMark) => {
            const userId = userMark.user.userId;
            if (!userCountMap[userId]) userCountMap[userId] = 1;

            const index = userCountMap[userId];
            userCountMap[userId] += 1;

            if (userMark.index !== index) {
                userMark = { ...userMark, index };
                hasChanged = true;
            }

            const updatedPoints = userMark.points.map((point) => {
                const [, second] = point.extraData?.split('.') ?? ['0', '0'];
                const newExtraData = `${index}${second ? `.${second}` : ''}`;
                const coordKey = `${point.lat},${point.lng}`;
                const newCount = countByCoordinates[coordKey];
                let modifiedPoint = point;

                if (point.extraData !== newExtraData) {
                    modifiedPoint = { ...modifiedPoint, extraData: newExtraData };
                    hasChanged = true;
                }

                if (
                    newCount !== undefined &&
                    newCount !== 1 &&
                    [PointType.UNITY, PointType.UNITYT_START_END, PointType.UNITY_END, PointType.UNITY_START].includes(point.type)
                ) {
                    modifiedPoint = { ...modifiedPoint, count: newCount };
                    hasChanged = true;
                }

                return modifiedPoint;
            });

            userMark.points = updatedPoints;
            updated[userMark.user.id] = userMark;
        });

        return hasChanged ? updated : prev;
    });
}, [activitySection, countByCoordinates]); */

    // Paso 2: Una vez actualizado visibleUsersDataGeneralList, asignar los índices
    useEffect(() => {
        if (activitySection !== ActivitySection.USER_LIST) return;

        //Buscar si hay más de 1 punto que coincida en una unidad, contar cuantos hay, editar la información para poner la cantidad de actividades que se muestran
        const countByCoordinates: Record<string, number> = {};
        const childrenByCoordinates: Record<string, ChildrenCoordinates[]> = {};

        for (const key in visibleUsersDataGeneralList) {
            const pointArray = visibleUsersDataGeneralList[key].points;
            for (const point of pointArray) {
                if (point.isUnity) {
                    const coordKey = `${point.lat},${point.lng}`;
                    countByCoordinates[coordKey] = (countByCoordinates[coordKey] || 0) + 1;
                    if (!childrenByCoordinates[coordKey]) {
                        childrenByCoordinates[coordKey] = [];
                    }

                    childrenByCoordinates[coordKey].push(
                        {
                            endDate: point.endProgramed,
                            endExecution: point.endDate,
                            isForcedClosure: point.isForceClose,
                            startDate: point.startProgramed,
                            startExecution: point.startDate,
                            status: point.status,
                            title: point.title,
                            typeProgramation: point.typeActivity,
                            userAssigned: point.userName
                        }
                    );
                }
            }
        }

        setVisibleUsersDataGeneralList((prev) => {
            const userCountMap: Record<string, number> = {};
            const updated = { ...prev };
            let hasChanged = false;

            Object.values(updated).forEach((userMark) => {
                const userId = userMark.user.userId;
                if (!userCountMap[userId]) userCountMap[userId] = 1;

                const index = userCountMap[userId];
                userCountMap[userId] += 1;

                // Solo modificamos si cambió
                if (userMark.index !== index) {
                    userMark = { ...userMark, index };
                    hasChanged = true;
                }

                const updatedPoints = userMark.points.map((point) => {
                    const [frist, second] = point.extraData?.split('.') ?? ['0', '0'];
                    const newExtraData = `${frist/* index */}${second ? `.${second}` : ''}`;
                    const coordKey = `${point.lat},${point.lng}`;
                    const newCount = countByCoordinates[coordKey];
                    if (point.extraData !== newExtraData) {
                        hasChanged = true;
                        return { ...point, extraData: newExtraData };
                    }
                    if (newCount !== undefined && point.count !== newCount/*  && newCount!==1 */ && [PointType.UNITY, PointType.UNITYT_START_END, PointType.UNITY_END, PointType.UNITY_START].includes(point.type)) {
                        hasChanged = true;
                        return { ...point, children: childrenByCoordinates[coordKey], count: newCount, type: newCount !== 1 ? PointType.UNITY : point.typeCopy };
                    }
                    return point;
                });

                userMark.points = updatedPoints;
                updated[userMark.user.id] = userMark;
            });

            return hasChanged ? updated : prev;
        });
    }, [visibleUsersDataGeneralList, activitySection]);


    /* useEffect(() => {
        if (activitySection !== ActivitySection.USER_LIST) return;

        setVisibleUsersDataGeneralList((prev) => {
            const userCountMap: Record<string, number> = {};
            const updated = { ...prev };

            // Contamos cuántos elementos hay por usuario
            Object.values(prev).forEach((userMark) => {
                const userId = userMark.user.userId;
                if (!userCountMap[userId]) {
                    userCountMap[userId] = 1;
                }
            });

            Object.values(updated).forEach((userMark) => {
                const userId = userMark.user.userId;
                const index = userCountMap[userId];
                userMark.index = index;

                userMark.points = userMark.points.map((point) => {
                    const [, second] = point.extraData?.split('.') ?? ['0', '0'];
                    return {
                        ...point,
                        extraData: `${index}${second ? `.${second}` : ''}`,
                    };
                });

                userCountMap[userId] += 1;
            });

            return updated;
        });
    }, [visibleUsersDataGeneralList, activitySection]); */

    const selectUserToHidden = (payload: { userId: string, list?: boolean, visible?: boolean, activitiesId?: string[] }) => {
        displayHidden({ id: payload.userId, list: payload.list, activitiesId: payload.activitiesId, visible: payload.visible })
    }

    const goToActivityDetail: BaseMenuClick = (item, payload) => {
        menuOptions({ item, payload: { ...payload, deleteActivity, seeReport, cancelActivity, finishActivity: confirmActiveOrFinish, forcedFinish: forceClosureActivity, reScheduleActivity, resend: resendActivity, startActivity: confirmActiveOrFinish }, })
    }

    const [hiddenLocalCopy, setHidenLocalCopy] = useState<string[]>([])

    const seeAll = () => {
        const updated = hiddenLocalConstant.filter(
            item => !hiddenLocalCopy.includes(item)
        );
        setHiddenLocalConstant(updated);

        const toAdd = hiddenLocalCopy.filter(item => !viewLocal.includes(item));
        setViewLocal([...viewLocal, ...toAdd]);
    };

    const hiddenAll = () => {

        setHiddenLocalConstant(hiddenLocalCopy);

        setViewLocal([]);

        const newVisibleUsers = usersMark;

        setVisibleUsersDataGeneralList(() => {
            const updated: Record<string, typeof newVisibleUsers[number]> = {};

            newVisibleUsers.forEach((userMark) => {
                updated[userMark.user.id] = { ...userMark }; // Copia directa, sin condición
            });

            return updated;
        });

    };

    function isOnlyPaginationChanged(prevQuery: string, newQuery: string): boolean {
        const parseQuery = (query: string) => {
            return Object.fromEntries(new URLSearchParams(query));
        };

        const prevParams = parseQuery(prevQuery);
        const newParams = parseQuery(newQuery);

        const keysToIgnore = ['page', 'size'];

        // Compara todos los filtros excepto page y size
        for (const key in prevParams) {
            if (!keysToIgnore.includes(key) && prevParams[key] !== newParams[key]) {
                return false; // Algún filtro cambió
            }
        }

        for (const key in newParams) {
            if (!keysToIgnore.includes(key) && prevParams[key] !== newParams[key]) {
                return false; // Algún filtro cambió
            }
        }

        return true; // Solo cambió page o size
    }

    const changeExpandMap = () => {
        setExpandMap(prev => !prev)
    }

    useEffect(() => {
        activities()
        setOldFilterString(filterUser.query.all ?? '')
        setIsPagination(isOnlyPaginationChanged(oldFilterString ?? '', filterUser.query.all ?? ''))
    }, [filterUser.query.all, usersIds])
    return (
        <>
            <Box sx={styles.mainContainer}>
                <Box sx={styles.containerUser(expandMap)}>
                    <UserActivity
                        loading={loadingContext.USER_LIST || loadingContext.GET_ACTIVITIES}
                        usersToDisplayed={hiddenLocalConstant}
                        usersToView={viewLocal}
                        hiddeAll={hiddenAll}
                        seeAll={seeAll}
                        displayActivityListUsers={({ users, list, activitiesId, visible }) => { selectUserToHidden({ userId: users, list: list, visible: visible, activitiesId: activitiesId }) }}
                        manualPagination={{
                            changePagination: ({ page }) => {
                                filterUser.handlePagination({ page, pageSize: 20 })
                                setPage(page)
                            },
                            page,
                            totalPages: total
                        }}
                        userList={userList}
                        menuOption={goToActivityDetail}
                        getActivities={activities}
                        query={`page=1&size=20&${returnQueryWithPagination(filterUser.query).replace('&', '')}`}
                        changeExpandMap={changeExpandMap}
                        expandMap={expandMap}
                    />
                </Box>

                <Box sx={styles.map(expandMap)}>
                    <Box sx={styles.containerHidenButon}>
                        <Button sx={styles.seeButons} onClick={changeExpandMap}>{expandMap ? t('loogbook.buttons.hiddenMap') : t('loogbook.buttons.seeMap')}</Button>
                    </Box>
                    <Box sx={styles.containerMap}>
                        <ActivityMap
                            hiddenUsers={hiddenLocalConstant}
                            usersMark={visibleUsersList}
                            loadings={{
                                left: loadingContext.USER_LIST,
                                right: false
                            }}
                        />
                    </Box>
                </Box>


            </Box>

            <FloatFilter
                cleanFilter={/*filterUser.cleanfilter*/cleanFilterAll}
                counter={filterUser.counter}
                onChange={/* filterUser.onChange */onChangeAll}
                values={filterUser.filterData}
                input={input}
                filter={false}
            />
            <SimpleModal
                open={!!modal?.open}
                close={closeModal}
                title={modal?.title}
                description={modal?.description}
                cancelText={modal?.cancelText ?? t('general.cancel')}
                buttonText={modal?.confirmText ?? t('general.confirm')}
                back={modal?.cancel}
                isLoading={!!modal?.loading}
                loadingButton
                next={modal?.confirm ?? closeModal}
                sx={modal.sx}
                children={modal.children}
                removeButtons={modal.removeButtons}
            />
            <SnackSimple
                close={closeSnackbar}
                open={snackbar.open}
                type={snackbar.type}
                message={snackbar.message}
            />
        </>
    )
}